import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {
  blackColor,
  whiteColor,
  hexToRgb,
} from "./../../assets/jss/material-dashboard-react";
import { Box } from "@mui/material";
export default function Card(props) {
  const { className, children, plain, profile, chart, ...rest } = props;

  return (
    <Box
      sx={[{
        border: "0",
        marginBottom: "30px",
        marginTop: "30px",
        borderRadius: "6px",
        color: "rgba(" + hexToRgb(blackColor) + ", 0.87)",
        background: whiteColor,
        width: "100%",
        boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        minWidth: "0",
        wordWrap: "break-word",
        fontSize: ".875rem"
      }, plain && {
        background: "transparent",
        boxShadow: "none",
      }, profile && {
        marginTop: "30px",
        textAlign: "center",
      }, className && {
        className: classNames({
          [className]: className !== undefined,
        }),
      }, chart && {
        "& p": {
          marginTop: "0px",
          paddingTop: "0px",
        },
      }]}
      {...rest}
    >
      {children}
    </Box>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node,
};
